<template>
    <div class="card onmaum-w-100">
        <div class="card-header">메뉴 관리</div>
        <div class="card-body">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-12">
                            <h6><i class="fas fa-list onmaum-text-red text-sm opacity-10"></i> 1차 메뉴</h6>
                        </div>
                        <div class="col-md-12">
                            <div class="onmaum-alert onmaum-alert-alarm" role="alert">
                                <ul>
                                    <li>URL 대/소문자 구분 주의!!</li>
                                    <li>이미지는 소스 > public 폴더 하위에 있어야함!</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0 onmaum-h-50-v onmaum-overflow onmaum-overflow-type02">
                        <table class="table table-striped text-center table align-items-center mb-0" style="table-layout: fixed;">
                            <thead>
                                <tr>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >ID</th>
                                    <!-- <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >Depth</th> -->
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="15%" >메뉴명</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="15%" >URL</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="15%" >서브배너 이미지</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="10%" >노출여부</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="10%" >사용여부</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="15%" >미사용멘트</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="20%" >기능</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(menu, i) in menuInfoTemp" :key="i">
                                    <!-- ID -->
                                    <td class="align-middle text-center text-sm">
                                        <p class="text-sm font-weight-bold mb-0">{{ menu._id }}</p>
                                    </td>
                                    <!-- Depth -->
                                    <!-- <td class="align-middle text-center text-sm">
                                        <p class="text-sm font-weight-bold mb-0">{{ menu.depth }}</p>
                                    </td> -->
                                    <!-- 메뉴명 -->
                                    <td class="align-middle text-center text-sm">
                                        <input class="form-control text-sm font-weight-bold mb-0" v-model="menu.title" :disabled="isDisabled(i)" />
                                    </td>
                                    <!-- URL -->
                                    <td class="align-middle text-center text-sm">
                                        <input class="form-control text-sm font-weight-bold mb-0" v-model="menu.url" :disabled="isDisabled(i)" />
                                    </td>
                                    <!-- 서브배너 이미지 -->
                                    <td class="align-middle text-center text-sm">
                                        <input class="form-control text-sm font-weight-bold mb-0" v-model="menu.subImg" :disabled="isDisabled(i)" />
                                    </td>
                                    <!-- 노출여부 -->
                                    <td class="align-middle text-center text-sm">
                                        <div class="form-check form-switch d-inline-block ">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="`isShow${i}`" :style="menu.isShow?`background-color:#FF931E; border-color: #FF931E;`:''" v-model="menu.isShow" :disabled="isDisabled(i)">
                                            <label class="form-check-label" :for="`isShow${i}`">
                                                <span class="badge onmaum-badge-default" v-if="menu.isShow">노출</span>
                                                <span class="badge onmaum-badge-regist" v-if="!menu.isShow">숨김</span>
                                            </label>
                                        </div>
                                    </td>
                                    <!-- 사용여부 -->
                                    <td class="align-middle text-center text-sm">
                                        <div class="form-check form-switch d-inline-block ">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="`isUse${i}`" :style="menu.isUse?`background-color:#5e72e4; border-color: #5e72e4;`:''" v-model="menu.isUse" :disabled="isDisabled(i)">
                                            <label class="form-check-label" :for="`isUse${i}`">
                                                <span class="badge bg-primary" v-if="menu.isUse">사용</span>
                                                <span class="badge onmaum-badge-regist" v-if="!menu.isUse">미사용</span>
                                            </label>
                                        </div>
                                    </td>
                                    <!-- 미사용 멘트 -->
                                    <td class="align-middle text-center text-sm">
                                        <input class="form-control text-sm font-weight-bold mb-0" v-model="menu.notice" :disabled="isDisabled(i)" />
                                    </td>
                                    <!-- 기능 -->
                                    <td class="align-middle text-center text-sm align-items-center">
                                        <button class="btn btn-link px-3 mb-0" @click="edit(i)" v-if="isDisabled(i)">
                                            <i class="fas fa-pencil-alt onmaum-text-contract me-2" aria-hidden="true"></i>편집
                                        </button>
                                        <button class="btn btn-link px-3 mb-0" @click="del(menu._id, i)" v-if="isDisabled(i)">
                                            <i class="fas fa-trash-alt onmaum-text-red me-2" aria-hidden="true"></i>삭제
                                        </button>
                                        <button class="btn btn-link px-3 mb-0" @click="save(menu, i)" v-if="!isDisabled(i)">
                                            <i class="fas fa-check-circle onmaum-text-success me-2" aria-hidden="true"></i>저장
                                        </button>
                                        <button class="btn btn-link px-3 mb-0" @click="cancel(i)" v-if="!isDisabled(i)">
                                            <i class="fas fa-times onmaum-text-black me-2" aria-hidden="true"></i>취소
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-3">
                            <h6><i class="fas fa-list onmaum-text-red text-sm opacity-10"></i> 신규 입력</h6>
                        </div>
                        <div class="col-6">

                        </div>
                        <div class="col-3">
                            <button class="btn btn-warning btn-sm ms-3 w-100" @click="insert()">입력</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-3">
                            <label for="menuTitle" class="form-control-label fs-5">메뉴명</label>
                            <input id="menuTitle" class="form-control invalid" type="text" v-model="menuNew.title" placeholder="메뉴명"/>
                        </div>
                        <div class="col-3">
                            <label for="menuUrl" class="form-control-label fs-5">URL</label>
                            <input id="menuUrl" class="form-control invalid" type="text" v-model="menuNew.url" placeholder="URL"/>
                        </div>
                        <div class="col-2">
                            <label for="menuSubImg" class="form-control-label fs-5">서브이미지</label>
                            <input id="menuSubImg" class="form-control invalid" type="text" v-model="menuNew.subImg" placeholder="서브이미지"/>
                        </div>
                        <div class="col-1">
                            <label class="form-control-label fs-5">노출여부</label>
                            <div class="form-check form-switch d-inline-block ">
                                <input class="form-check-input" type="checkbox" role="switch" id="isShow" :style="menuNew.isShow?`background-color:#FF931E; border-color: #FF931E;`:''" v-model="menuNew.isShow" :disabled="isDisabled(i)">
                                <label class="form-check-label" for="isShow">
                                    <span class="badge onmaum-badge-default" v-if="menuNew.isShow">노출</span>
                                    <span class="badge onmaum-badge-regist" v-if="!menuNew.isShow">숨김</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-1">
                            <label class="form-control-label fs-5">사용여부</label>
                            <div class="form-check form-switch d-inline-block ">
                                <input class="form-check-input" type="checkbox" role="switch" id="isUse" :style="menuNew.isUse?`background-color:#5e72e4; border-color: #5e72e4;`:''" v-model="menuNew.isUse" :disabled="isDisabled(i)">
                                <label class="form-check-label" for="isUse">
                                    <span class="badge bg-primary" v-if="menuNew.isUse">사용</span>
                                    <span class="badge onmaum-badge-regist" v-if="!menuNew.isUse">미사용</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-2">
                            <label for="menuNotice" class="form-control-label fs-5">미사용멘트</label>
                            <input id="menuNotice" class="form-control invalid" type="text" v-model="menuNew.notice" placeholder="미사용멘트"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MenuManage',
    data() {
        return {
            menuInfoTemp: [],
            disabled: [],
            menuNew: {
                depth: 1
                ,title: ''
                ,url: ''
                ,subImg: ''
                ,isShow: false
                ,isUse: false
                ,notice: ''
                ,items: null
                ,sort: 0
            }
        }
    },

    methods:{
        edit(id) {
            this.disabled[id] = false;
            this.resetInfo();
        },

        async del(_id, id) {
            if(confirm('삭제하시겠습니까?')){
                await this.$store.dispatch('deleteMenuInfo', {_id: _id});
                this.disabled.splice(id, 1);
                this.resetInfo();
            }
        },

        async save(list, id) {
            if(list.isShow && !list.isUse && list.notice == ''){
                alert('미사용멘트 입력 필요');
                return;
            }

            if(confirm('저장하시겠습니까?')){
                await this.$store.dispatch('modifyMenuInfo', list);
                this.disabled[id] = true;
                this.resetInfo();
            }
        },

        cancel(id) {
            this.disabled[id] = true;
            this.resetInfo();
        },
        
        isDisabled(id) {
            return this.disabled[id];
        },

        async insert() {
            if(this.menuNew.isShow && !this.menuNew.isUse && this.menuNew.notice == ''){
                alert('미사용멘트 입력 필요');
                return;
            }

            if(confirm('입력하시겠습니까?')){
                await this.$store.dispatch('insertMenuInfo', this.menuNew);
                this.disabled.push(true);
                this.resetInfo();
                this.resetTemp();
            }
        },

        resetInfo() {
            this.menuInfoTemp = JSON.parse(JSON.stringify(this.menuInfo));
        },

        resetTemp() {
            this.menuNew = {
                depth: 1
                ,title: ''
                ,url: ''
                ,subImg: ''
                ,isShow: false
                ,isUse: false
                ,notice: ''
                ,items: null
                ,sort: 0
            }
        },
    },

    computed: {
        menuInfo() {
            return this.$store.state.hondi.menuInfo;
        }
    },

    async mounted() {
        await this.$store.dispatch('getMenuInfo');
        this.disabled = Array.from({ length: this.menuInfo.length }, () => true);
        this.resetInfo();
    },
}
</script>

<style>

</style>